import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-personal",
  "use": "icon-personal-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-personal\"><path d=\"M514.56 265.856m-214.4 0a214.4 214.4 0 1 0 428.8 0 214.4 214.4 0 1 0-428.8 0Z\" fill=\"#333333\" p-id=\"39539\" /><path d=\"M514.56 501.696c213.12 0 385.92 172.8 385.92 385.92 0 47.36-38.4 85.76-85.76 85.76H214.4C167.04 973.376 128.64 934.976 128.64 887.616l0.256-14.464A385.92 385.92 0 0 1 514.56 501.696z\" fill=\"#333333\" p-id=\"39540\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol